import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from 'react-select';

import "./Structure.css"

import history from "../../../../history";
import { getAllUsers } from "../../../../actions/userActions";
import { getAllUnits, getStructure } from "../../../../actions/structureActions";
import { getAllExternalUnits } from "../../../../actions/externalUnitActions";

class Structure extends React.Component {
    componentDidMount() {
        this.props.getAllUsers();
        this.props.getAllUnits();
        this.props.getAllExternalUnits();
        this.props.getStructure(this.props.match.params.ouID ? this.props.match.params.ouID : null);
        
        this.unlisten = history.listen(location => {
            if (location.pathname.substring(location.pathname.lastIndexOf('/') - 5).startsWith("/unit/")) {
                this.props.getStructure(location.pathname.substring(location.pathname.lastIndexOf('/') + 1));

            } else if (location.pathname.substring(location.pathname.lastIndexOf('/') - 5) === "/structure") {
                this.props.getStructure();
            }
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    renderUnitsOptions = (prefix, units) => {
        let options = []
        units.forEach(unit => {
            options.push({ label: `${prefix} ${unit.symbol} | ${unit.name}`, value: unit.ouID });
            options = [
                ...options,
                ...this.renderUnitsOptions(`${prefix}_`, unit.subOUs)
            ]
        })
        return options
    };

    renderUnits = (type) => (type === "external" ? this.props.externalUnitsList : this.props.structure.subUnits).map(subUnit => {
        return (
            <div className="row" key={type === "external" ? subUnit.externalOuID : subUnit.ouID}>
                <div className="two wide column marker">
                    <i className="big angle right icon" />
                </div>
                <div className="fourteen wide column">
                    <div className="ui segment-wrapper">
                        <div className="ui segment" onClick={() => this.linkTo(type === "external" ? `/structure/external/details/${subUnit.externalOuID}` : `/structure/unit/${subUnit.ouID}`)}>
                            {this.renderUnit(type, subUnit)}
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    renderUnit = (type, subUnit = null) => {
        return (
            <div className={`ui${subUnit ? "" : " header"} grid`}>
                <div className="five wide column">
                    <div className="content">{subUnit ? (type === "external" ? subUnit.externalOuID : subUnit.ouID) : "Numer jednostki"}</div>
                </div>
                <div className="five wide column">
                    <div className="content">{subUnit ? (type === "external" ? subUnit.name : subUnit.symbol) : (type === "external" ? "Nazwa" : "Symbol")}</div>
                </div>
                <div className="six wide column">
                    <div className={`${(type === "external" && subUnit && subUnit.active !== 1) ? "red" : ""} content`}>{subUnit ? (type === "external" ? (subUnit.active === 1 ? "Tak" : "Nie") : subUnit.name) : (type === "external" ? "Aktywna" : "Nazwa")}</div>
                </div>
            </div>
        );
    };

    renderUsers = (type, users = null) => users.map(user => {
        return (
            <div className="ui segment-wrapper" key={user.userID}>
                <div className="ui segment" onClick={() => this.linkTo(`/users/details/${user.userID}`)}>
                    {this.renderUser(type, user)}
                </div>
            </div>
        );
    });

    renderUser = (type, user = null) => {
        return (
            <div className={`ui${user ? "" : " header"} grid`}>
                <div className={`${type === "supervisor" ? "three" : "four"} wide column`}>
                    <div className="content">{user ? user.userID : "Numer ewidencyjny"}</div>
                </div>
                <div className={`${type === "supervisor" ? "four" : "six"} wide column`}>
                    <div className="content">{user ? `${user.lname} ${user.fname}` : "Nazwisko i imię"}</div>
                </div>
                <div className={`${type === "supervisor" ? "four" : "six"} wide column`}>
                    <div className="content">{user ? user.email : "Email"}</div>
                </div>
                {type === "supervisor" ? (
                    <div className="five wide column">
                        <div className="content">{user ? (
                            <React.Fragment>
                                {user.priority === 1 ? "Przełożony" : "Zastępca przełożonego"}<br />
                                {!user.dateFrom && !user.dateTo ? "Stały" : "Tymczasowy"}<br />
                                {user.dateFrom && user.dateTo ? `Od ${user.dateFrom} do ${user.dateTo}` : ""}
                            </React.Fragment>
                        ) : "Informacje o przełożonym"}</div>
                    </div>
                ) : null}
            </div>
        );
    };

    linkTo = destination => history.push(destination);

    render() {
        return (
            <React.Fragment>
                <div className="structure-component ui container">
                    <div className="ui three item menu">
                        <Link to="/structure" className="active item">
                            <div className="content">Struktura firmy</div>
                        </Link>
                        <Link to="/absence/reasons" className="item">
                            <div className="content">Przyczyny absencji</div>
                        </Link>
                        <Link to="/settings" className="item">
                            <div className="content">Pozostałe ustawienia</div>
                        </Link>
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        <div className="ui two column grid">
                            <div className="column">
                                <Select
                                    onChange={value => this.linkTo(`/structure${value.value ? `/unit/${value.value}` : ""}`)}
                                    options={[{ label: "Medcom", value: null }, ...this.renderUnitsOptions("_", this.props.unitsList)]}
                                    placeholder="Wyszukaj jednostkę organizacyjną..."
                                    noOptionsMessage={() => "Nie znaleziono jednostki organizacyjnej"}
                                    maxMenuHeight="600px"
                                />
                            </div>
                            <div className="column">
                                <Select
                                    onChange={value => this.linkTo(`/users/details/${value.value}`)}
                                    options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u.userID } })]}
                                    placeholder="Wyszukaj użytkownika..."
                                    noOptionsMessage={() => "Nie znaleziono użytkownika"}
                                    maxMenuHeight="600px"
                                />
                            </div>
                        </div>
                        <div className="ui divider" />
                        <div className={`ui ${this.props.structure.unit.ouID ? "two" : "one"} column grid`}>
                            {this.props.structure.unit.ouID ? (
                                <div className="column" onClick={() => this.linkTo(`/structure${this.props.structure.unit.parentOuID ? `/unit/${this.props.structure.unit.parentOuID}` : ``}`)}>
                                    <h2 className="ui icon header">
                                        <i className="arrow alternate circle up icon"></i>
                                        <div className="header">{this.props.structure.unit.parentOuName ? this.props.structure.unit.parentOuName : "Medcom"}</div>
                                    </h2>
                                </div>
                            ) : null}
                            <div className="column">
                                <h2 className="ui icon header">
                                    <i className="sitemap icon"></i>
                                    <div className="header">{this.props.structure.unit.name}</div>
                                    {this.props.structure.unit.ouID ? (
                                        <div className="content">{`${this.props.structure.unit.ouID} | ${this.props.structure.unit.symbol}`}</div>
                                    ) : null}
                                </h2>
                            </div>
                        </div>
                        <div className="ui divider" />
                        {this.props.structure.unit.ouID ? (
                            <React.Fragment>
                                <div className="ui large header">
                                    <div className="content">Ustawienia&ensp;</div>
                                    <div className="small content">
                                        ( <Link to={`/structure/edit/settings/${this.props.structure.unit.ouID}`}>Edytuj</Link> )
                                    </div>
                                </div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="header">Wymagaj potwierdzenia w jednostce nadrzędnej:</td>
                                            <td>{["wszystkich wniosków", "tylko wniosków przełożonych", "żadnych wniosków"][this.props.structure.unit.parentAcceptMode]}</td>
                                        </tr>
                                        <tr>
                                            <td className="header">W przypadku braku przełożonego:</td>
                                            <td>{["wymagaj potwierdzenia mimo to", "nie wymagaj potwierdzenia"][this.props.structure.unit.currentAcceptMode]}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="ui divider" />
                            </React.Fragment>
                        ) : null}
                        <div className="ui large header">
                            <div className="content">Jednostki podległe&ensp;</div>
                            <div className="small content">
                                ( <Link to={`/structure/edit/sub-units${this.props.structure.unit.ouID ? `/${this.props.structure.unit.ouID}` : ""}`}>Edytuj</Link> )
                            </div>
                        </div>
                        {this.props.structure.subUnits.length ? (
                            <React.Fragment>
                                <div className="ui grid middle aligned">
                                    <div className="row">
                                        <div className="two wide column marker" />
                                        <div className="fourteen wide column">
                                            {this.renderUnit("internal")}
                                        </div>
                                    </div>
                                    {this.renderUnits("internal")}
                                </div>
                            </React.Fragment>
                        ) : (
                            <div className="ui small header">
                                <div className="content">Brak jednostek podległych</div>
                            </div>
                        )}
                        {!this.props.structure.unit.ouID ? (
                            <React.Fragment>
                                <div className="ui divider" />
                                <div className="ui large header">
                                    <div className="content">Firmy zewnętrzne&ensp;</div>
                                    <div className="small content">
                                        ( <Link to={`/structure/external/new`}>Nowa firma zewnętrzna</Link> )
                                    </div>
                                </div>
                                {this.props.externalUnitsList.length ? (
                                    <div className="ui grid middle aligned">
                                        <div className="row">
                                            <div className="two wide column marker" />
                                            <div className="fourteen wide column">
                                                {this.renderUnit("external")}
                                            </div>
                                        </div>
                                        {this.renderUnits("external")}
                                    </div>
                                ) : (
                                    <div className="ui small header">
                                        <div className="content">Brak firm zewnętrznych</div>
                                    </div>
                                )}
                            </React.Fragment>
                        ) : null}
                        {this.props.structure.unit.ouID ? (
                            <React.Fragment>
                                <div className="ui divider" />
                                <div className="ui large header">
                                    <div className="content">Przełożeni jednostki&ensp;</div>
                                    <div className="small content">
                                        ( <Link to={`/structure/edit/supervisors/${this.props.structure.unit.ouID}`}>Edytuj</Link> )
                                    </div>
                                </div>
                                {this.props.structure.supervisors.length ? (
                                    <React.Fragment>
                                        {this.renderUser("supervisor")}
                                        {this.renderUsers("supervisor", this.props.structure.supervisors)}
                                    </React.Fragment>
                                ) : (
                                    <div className="ui small header">
                                        <div className="content">Brak przełożonych jednostki</div>
                                    </div>
                                )}
                            </React.Fragment>
                        ) : null}
                        {(this.props.structure.employees.length || this.props.structure.unit.ouID) ? (
                            <React.Fragment>
                                <div className="ui divider" />
                                <div className="ui large header">
                                    <div className="content">{this.props.structure.unit.ouID ? "Pracownicy jednostki" : "Pracownicy nieprzypisani"}&ensp;</div>
                                    <div className="small content">
                                        ( <Link to={`/structure/edit/employees${this.props.structure.unit.ouID ? `/${this.props.structure.unit.ouID}` : ""}`}>Edytuj</Link> )
                                    </div>
                                </div>
                                {this.props.structure.employees.length ? (
                                    <React.Fragment>
                                        {this.renderUser("employee")}
                                        {this.renderUsers("employee", this.props.structure.employees)}
                                    </React.Fragment>
                                ) : (
                                    <div className="ui small header">
                                        <div className="content">Brak pracowników jednostki</div>
                                    </div>
                                )}
                            </React.Fragment>
                        ) : null}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    unitsList: state.structure.list,
    usersList: state.user.list,
    structure: state.structure,
    externalUnitsList: state.externalUnit.list
});

export default connect(mapStateToProps, { getAllUsers, getAllUnits, getStructure, getAllExternalUnits })(Structure);